import { MedicationFragmentInline$data } from "@/modules/patients/detail/medication/types/medication-fragment-type"
import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { CarePlanMedicationInput } from "@/modules/patients/services/ch/__generated__/chSaveCarePlanDataMutation.graphql"
import { CarePlanTherapy } from "@/types/__generated__/union-types"

const buildChCarePlanData = (
  progressNote: ProgressNoteData,
  medications: MedicationFragmentInline$data[],
): { medications: CarePlanMedicationInput[]; therapies: CarePlanTherapy[] } => {
  if (progressNote.__typename !== "ch_ProgressNote") {
    return { medications: [], therapies: [] }
  }

  const medicationIds = progressNote.prescription?.medications.map((medication) => medication.id) ?? []
  const carePlanMedications: CarePlanMedicationInput[] = medications
    .filter((medication) => medicationIds.includes(medication.id))
    .map(({ name, usageInstructions, morningDosage, noonDosage, eveningDosage, nightDosage, unit }) => ({
      name,
      usageInstruction: usageInstructions,
      morningDosage,
      noonDosage,
      eveningDosage,
      nightDosage,
      asNeeded: unit === "PRN",
    }))

  const therapies: CarePlanTherapy[] = []
  if (progressNote.ch_nutritionalPrescription) {
    therapies.push("NUTRITIONAL_COUNSELLING")
  }
  if (progressNote.physiotherapy) {
    therapies.push("PHYSIOTHERAPY")
  }
  if (progressNote.psychologicalPsychotherapy) {
    therapies.push("PSYCHOTHERAPY")
  }

  return { medications: carePlanMedications, therapies }
}

export { buildChCarePlanData }
